import axios from 'axios'
//import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_CS + '/',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    if (!config.params) {
      config.params = {}
    }
    //console.log("config.params:", config.params)
    if (store.getters.token) {
      config.params.uid = store.getters.token.id
      config.params.actoken = store.getters.token.token
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    //console.log("response:",response)
    if (response.data.desc === 'illegal login') {
      store.dispatch('user/logout')
      //router.push(`/login?redirect=${router.app.$route.fullPath}`)
      router.push(`/login?redirect=${router.currentRoute.value.fullPathh}`)
      
    }
    return response.data
  },
  (error) => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    //alert(error.message)
    return Promise.reject(error)
  }
)

export default service
